import { ComponentProps, forwardRef } from 'react';

import cx from 'classnames';

import { TColors, TSizesExtended } from '../../types';

import styles from './TextBlock.module.scss';

export type TTextProps = {
  align?: 'left' | 'center' | 'right';
  color?: TColors;
  line?: '100' | '125' | '150' | 'normal';
  size?: TSizesExtended;
  transform?: 'lowercase' | 'uppercase' | 'capitalize';
  translateY?: number;
  variant?: 'body' | 'subtitle';
  weight?: '400' | '600';
  wrap?: 'normal' | 'nowrap' | 'break' | 'preLine';
} & Omit<ComponentProps<'div'>, 'color' | 'ref'>;

export const TextBlock = forwardRef<HTMLDivElement, TTextProps>(function Text(
  {
    align,
    className,
    color,
    line,
    size = 'm',
    style,
    transform,
    translateY,
    variant = 'body',
    weight,
    wrap,
    ...rest
  },
  ref,
) {
  return (
    <div
      {...rest}
      className={cx(
        className,
        color ? styles[color] : styles.text,
        size && styles[variant + '__' + size],
        align && styles[align],
        transform && styles[transform],
        wrap && styles[wrap],
        line && styles[`line-${line}`],
        weight && styles[`weight-${weight}`],
      )}
      ref={ref}
      style={{ ...style, transform: `translateY(${translateY}px)` }}
    />
  );
});
